import { useEffect, useState } from "react";
import { Box, keyframes } from "@mui/material";
import { useLocation } from "react-router-dom";
import { getWebsitePopup } from "../../apis/websitePopupApi";

const marquee = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const OfferBanner = () => {
  const { pathname } = useLocation();
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    if (pathname !== "/") {
      setText(null);
      return;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const data = await getWebsitePopup();
        if (cancelled) return;
        if (data?.bannerEnabled && data.bannerText?.trim()) {
          setText(data.bannerText.trim());
        } else {
          setText(null);
        }
      } catch (error) {
        console.error("Failed to load offer banner:", error);
        if (!cancelled) setText(null);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [pathname]);

  if (pathname !== "/" || !text) return null;

  // Duplicate text so the CSS loop looks continuous
  const segment = `${text}   •    `;
  const loopText = segment.repeat(6);

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        width: "100%",
        bgcolor: "#c9a227",
        color: "#1a1625",
        overflow: "hidden",
        whiteSpace: "nowrap",
        py: 1.25,
        borderBottom: "1px solid rgba(0,0,0,0.12)",
      }}
    >
      <Box
        sx={{
          display: "inline-block",
          whiteSpace: "nowrap",
          animation: `${marquee} 50s linear infinite`,
          fontWeight: 700,
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
          letterSpacing: "0.03em",
          textTransform: "uppercase",
        }}
      >
        <Box component="span" sx={{ display: "inline-block", pr: 0 }}>
          {loopText}
        </Box>
        <Box component="span" sx={{ display: "inline-block", pr: 0 }}>
          {loopText}
        </Box>
      </Box>
    </Box>
  );
};

export default OfferBanner;
